import CreateLoanLink from './CreateLoanLink';

export default CreateLoanLink;